(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bnp-complete-set"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('bnp-complete-set')) return;

    var ALIASES = {
      xsmall: 'xs', extrasmall: 'xs', small: 's', sm: 's', medium: 'm', med: 'm', large: 'l', lg: 'l',
      xlarge: 'xl', extralarge: 'xl', xxl: '2xl', xxlarge: '2xl', '2xlarge': '2xl', xxxl: '3xl',
      xxxlarge: '3xl', '3xlarge': '3xl', xxxxl: '4xl', '4xlarge': '4xl', '5xlarge': '5xl',
      '6xlarge': '6xl', '7xlarge': '7xl', onesize: 'os'
    };

    function norm(value) {
      var s = String(value == null ? '' : value).toLowerCase();
      var inner = s.match(/\(([^)]+)\)/);
      if (inner) s = inner[1];
      s = s.replace(/[^a-z0-9]/g, '');
      return ALIASES[s] || s;
    }

    function fill(template, values) {
      return String(template || '').replace(/__(\w+)__/g, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    }

    function formatMoney(cents, format) {
      var value = Number(cents) || 0;
      var pattern = /\{\{\s*(\w+)\s*\}\}/;
      var template = format || ('$' + '{' + '__amount__' + '}');
      function withDelimiters(amount, precision, thousands, decimal) {
        var fixed = (amount / 100).toFixed(precision);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
      }
      var match = template.match(pattern);
      var formatted;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          formatted = withDelimiters(value, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          formatted = withDelimiters(value, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = withDelimiters(value, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          formatted = withDelimiters(value, 2, "'", '.');
          break;
        default:
          formatted = withDelimiters(value, 2, ',', '.');
      }
      var output = template.replace(pattern, formatted);
      var holder = document.createElement('textarea');
      holder.innerHTML = output;
      return holder.value;
    }

    function pageRadios(formId, name) {
      return Array.prototype.filter.call(document.querySelectorAll('input[type="radio"]'), function (input) {
        return input.name === 'options[' + name + ']' && (!formId || input.getAttribute('form') === formId);
      });
    }

    function pageValue(formId, name) {
      var checked = pageRadios(formId, name).find(function (input) {
        return input.checked;
      });
      if (checked) return checked.value;
      var form = formId ? document.getElementById(formId) : null;
      var root = (form && form.closest('[data-product-form-wrapper]')) || document;
      var wrapper = Array.prototype.find.call(root.querySelectorAll('[data-select-label]'), function (node) {
        return node.dataset.selectLabel === name;
      });
      var current = wrapper && wrapper.querySelector('.select-popout__item--current [data-value], [data-value][aria-current="true"]');
      return current ? current.dataset.value : null;
    }

    class BnpCompleteSet extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        var dataNode = this.querySelector('script[data-bnp-set-data]');
        if (!dataNode) return;
        try {
          this.data = JSON.parse(dataNode.textContent);
        } catch (e) {
          return;
        }
        this._ready = true;
        if (this.dataset.mode !== 'upsell') return;

        this.labels = this.data.labels || {};
        this.options = this.data.options || [];
        this.variants = this.data.variants || [];
        this.selection = this.options.map(function () { return null; });
        this.fieldsets = Array.prototype.slice.call(this.querySelectorAll('[data-bnp-set-option]'));
        this.addButton = this.querySelector('[data-bnp-set-add]');
        this.message = this.querySelector('[data-bnp-set-msg]');
        this.priceNode = this.querySelector('[data-bnp-set-price]');
        this.links = this.buildLinks();

        this.fieldsets.forEach(function (fieldset) {
          var index = Number(fieldset.dataset.bnpSetOption);
          fieldset.querySelectorAll('.bnp-set__pill').forEach(function (pill) {
            pill.addEventListener('click', function () {
              this.choose(index, pill.dataset.value);
            }.bind(this));
          }, this);
          var guideButton = fieldset.querySelector('[data-bnp-set-guide]');
          if (guideButton) {
            guideButton.addEventListener('click', function () {
              var guide = document.getElementById(this.dataset.guide);
              if (guide && guide.openForOption) guide.openForOption(this.options[index]);
            }.bind(this));
          }
        }, this);

        if (this.addButton) this.addButton.addEventListener('click', this.add.bind(this));

        this.onPageChange = function (event) {
          var input = event.target;
          if (!input || typeof input.name !== 'string' || input.name.indexOf('options[') !== 0) return;
          if (this.dataset.formId && input.getAttribute('form') !== this.dataset.formId) return;
          window.requestAnimationFrame(this.mirrorPage.bind(this, true));
        }.bind(this);
        this.onPageClick = function (event) {
          if (event.target && event.target.closest && event.target.closest('[data-popout-option]')) {
            window.setTimeout(this.mirrorPage.bind(this, true), 0);
          }
        }.bind(this);
        this.onSectionUpdate = function () {
          window.requestAnimationFrame(this.mirrorPage.bind(this, false));
        }.bind(this);
        document.addEventListener('change', this.onPageChange);
        document.addEventListener('click', this.onPageClick);
        window.addEventListener('theme:section:update', this.onSectionUpdate);

        this.mirrorPage(false);
        this.render();
      }

      disconnectedCallback() {
        if (this.onPageChange) document.removeEventListener('change', this.onPageChange);
        if (this.onPageClick) document.removeEventListener('click', this.onPageClick);
        if (this.onSectionUpdate) window.removeEventListener('theme:section:update', this.onSectionUpdate);
        this._ready = false;
      }

      buildLinks() {
        var pageTitle = String(this.data.pageTitle || '').toLowerCase().trim();
        var pageSizeOption = (this.data.pageOptions || []).find(function (name) {
          return /size/i.test(name);
        }) || (this.data.pageOptions || [])[0] || null;
        if (!pageTitle || !pageSizeOption) return [];
        return this.options.map(function (name, index) {
          return name.toLowerCase().indexOf(pageTitle) !== -1 ? { index: index, pageOption: pageSizeOption } : null;
        }).filter(Boolean);
      }

      mirrorPage(flash) {
        this.links.forEach(function (link) {
          var value = pageValue(this.dataset.formId, link.pageOption);
          if (value == null) return;
          var key = norm(value);
          var match = this.valuesFor(link.index).find(function (candidate) {
            return norm(candidate) === key;
          });
          if (match && this.selection[link.index] !== match) {
            this.selection[link.index] = match;
            this.render();
            if (flash) this.flash(link.index);
          }
        }, this);
      }

      valuesFor(index) {
        var fieldset = this.fieldsets.find(function (node) {
          return Number(node.dataset.bnpSetOption) === index;
        });
        if (!fieldset) return [];
        return Array.prototype.map.call(fieldset.querySelectorAll('.bnp-set__pill'), function (pill) {
          return pill.dataset.value;
        });
      }

      flash(index) {
        var fieldset = this.fieldsets.find(function (node) {
          return Number(node.dataset.bnpSetOption) === index;
        });
        var pill = fieldset && fieldset.querySelector('.bnp-set__pill[aria-pressed="true"]');
        if (!pill) return;
        pill.classList.remove('is-flash');
        void pill.offsetWidth;
        pill.classList.add('is-flash');
      }

      choose(index, value) {
        if (!this.isValueAvailable(index, value)) {
          if (!this.isValueAvailable(index, value, true)) return;
          this.selection = this.selection.map(function (current, i) {
            return i === index ? value : null;
          });
        }
        this.selection[index] = value;
        if (this.message) {
          this.message.textContent = '';
          this.message.classList.remove('is-error');
        }
        this.render();
        this.dispatchEvent(new CustomEvent('bnp:set:change', { bubbles: true }));
      }

      getSize(name) {
        var index = this.options.indexOf(name);
        return index === -1 ? null : this.selection[index];
      }

      setSize(name, value) {
        var index = this.options.indexOf(name);
        if (index !== -1) this.choose(index, value);
      }

      isValueAvailable(index, value, ignoreOthers) {
        var selection = this.selection;
        return this.variants.some(function (variant) {
          if (!variant.a || variant.o[index] !== value) return false;
          if (ignoreOthers) return true;
          return variant.o.every(function (optionValue, i) {
            return i === index || selection[i] == null || selection[i] === optionValue;
          });
        });
      }

      currentVariant() {
        if (!this.options.length) return this.variants[0] || null;
        if (this.selection.some(function (value) { return value == null; })) return null;
        var selection = this.selection;
        return this.variants.find(function (variant) {
          return variant.o.every(function (value, i) {
            return value === selection[i];
          });
        }) || null;
      }

      blockedIndex() {
        return this.selection.findIndex(function (value, i) {
          return value != null && !this.isValueAvailable(i, value);
        }, this);
      }

      render() {
        var blocked = this.blockedIndex();
        this.fieldsets.forEach(function (fieldset) {
          var index = Number(fieldset.dataset.bnpSetOption);
          var selected = this.selection[index];
          fieldset.querySelectorAll('.bnp-set__pill').forEach(function (pill) {
            var value = pill.dataset.value;
            pill.setAttribute('aria-pressed', value === selected ? 'true' : 'false');
            pill.classList.toggle('is-unavailable', value === selected && index === blocked);
            pill.disabled = !this.isValueAvailable(index, value, true) && value !== selected;
          }, this);
          var label = fieldset.querySelector('[data-bnp-set-value]');
          if (label) label.textContent = selected || '';
        }, this);

        var variant = this.currentVariant();
        if (variant && this.priceNode) this.priceNode.textContent = formatMoney(variant.p, this.data.moneyFormat);

        if (!this.addButton || this.addButton.classList.contains('is-loading')) return;
        var missing = this.selection.findIndex(function (value) { return value == null; });
        if (blocked !== -1) {
          this.addButton.disabled = true;
          this.addButton.textContent = this.labels.unavailable;
        } else if (missing !== -1) {
          var name = this.options[missing].replace(/\(size\)/i, '').trim();
          this.addButton.disabled = true;
          this.addButton.textContent = fill(this.labels.choose, { option: name });
        } else if (!variant || !variant.a) {
          this.addButton.disabled = true;
          this.addButton.textContent = this.labels.unavailable;
        } else {
          this.addButton.disabled = false;
          this.addButton.textContent = this.labels.button + ' — ' + formatMoney(variant.p, this.data.moneyFormat);
        }
      }

      async add() {
        var variant = this.currentVariant();
        if (!variant || !variant.a || this.addButton.classList.contains('is-loading')) return;
        var routes = this.data.routes || {};
        var hadFocus = document.activeElement === this.addButton;
        this.addButton.classList.add('is-loading');
        this.addButton.setAttribute('aria-disabled', 'true');
        this.addButton.textContent = this.labels.adding;
        this.message.textContent = '';
        this.message.classList.remove('is-error');

        var added = false;
        try {
          var response = await fetch((routes.add || '/cart/add') + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
          if (!response.ok) {
            var body = await response.json().catch(function () { return {}; });
            if (response.status === 422) variant.a = false;
            var failure = new Error('cart');
            failure.userMessage = body.description || body.message || '';
            throw failure;
          }
          added = true;
        } catch (error) {
          this.message.textContent = (error && error.userMessage) || this.labels.error;
          this.message.classList.add('is-error');
        }

        this.addButton.classList.remove('is-loading');
        this.addButton.removeAttribute('aria-disabled');
        this.render();

        if (!added) {
          if (hadFocus) this.addButton.focus();
          return;
        }

        this.message.textContent = this.labels.added;
        try {
          var cartResponse = await fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } });
          var cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        } catch (refreshError) {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        }
        if (typeof window.monster_refresh === 'function') {
          try {
            await window.monster_refresh(true);
            return;
          } catch (monsterError) {}
        }
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        } else {
          window.location.href = routes.cart || '/cart';
        }
      }
    }

    customElements.define('bnp-complete-set', BnpCompleteSet);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bnp-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('bnp-size-guide')) return;

    var ALIASES = {
      xsmall: 'xs', extrasmall: 'xs', small: 's', sm: 's', medium: 'm', med: 'm', large: 'l', lg: 'l',
      xlarge: 'xl', extralarge: 'xl', xxl: '2xl', xxlarge: '2xl', '2xlarge': '2xl', xxxl: '3xl',
      xxxlarge: '3xl', '3xlarge': '3xl', xxxxl: '4xl', '4xlarge': '4xl', '5xlarge': '5xl',
      '6xlarge': '6xl', '7xlarge': '7xl', onesize: 'os'
    };

    function norm(value) {
      var s = String(value == null ? '' : value).toLowerCase();
      var inner = s.match(/\(([^)]+)\)/);
      if (inner) s = inner[1];
      s = s.replace(/[^a-z0-9]/g, '');
      return ALIASES[s] || s;
    }

    function num(value) {
      var n = parseFloat(value);
      return isFinite(n) ? n : null;
    }

    function fill(template, values) {
      return String(template || '').replace(/__(\w+)__/g, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    }

    function el(tag, attrs, children) {
      var node = document.createElement(tag);
      if (attrs) {
        Object.keys(attrs).forEach(function (key) {
          var value = attrs[key];
          if (value == null || value === false) return;
          if (key === 'text') node.textContent = value;
          else if (key === 'className') node.className = value;
          else node.setAttribute(key, value === true ? '' : value);
        });
      }
      (children || []).forEach(function (child) {
        if (child == null) return;
        node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
      });
      return node;
    }

    var SVG_NS = 'http://www.w3.org/2000/svg';
    function svg(tag, attrs) {
      var node = document.createElementNS(SVG_NS, tag);
      Object.keys(attrs || {}).forEach(function (key) {
        node.setAttribute(key, attrs[key]);
      });
      return node;
    }

    var UNIT_KEY = 'bnp-size-unit';
    function readUnit(fallback) {
      try {
        return window.localStorage.getItem(UNIT_KEY) || fallback;
      } catch (e) {
        return fallback;
      }
    }
    function saveUnit(unit) {
      try {
        window.localStorage.setItem(UNIT_KEY, unit);
      } catch (e) {}
    }

    var FRACTIONS = ['', '¼', '½', '¾'];
    function formatValue(value, baseUnit, unit) {
      if (value == null) return '—';
      var inches = baseUnit === 'cm' ? value / 2.54 : value;
      if (unit === 'cm') {
        var cm = baseUnit === 'cm' ? value : value * 2.54;
        return (Math.round(cm * 2) / 2).toString() + ' cm';
      }
      var whole = Math.floor(inches + 1e-9);
      var quarters = Math.round((inches - whole) * 4);
      if (Math.abs((inches - whole) * 4 - quarters) > 0.05) {
        return (Math.round(inches * 10) / 10).toString() + '"';
      }
      if (quarters === 4) {
        whole += 1;
        quarters = 0;
      }
      return whole + FRACTIONS[quarters] + '"';
    }

    var GARMENT_PATTERNS = {
      tee: /\b(t[\s-]?shirts?|tees?)\b/i,
      jacket: /\b(jackets?|coach)\b/i,
      hoodie: /\bhood(ie)?s?\b/i,
      crewneck: /\b(crew(neck)?s?|sweaters?|sweatshirts?)\b/i
    };

    var MEASURES = ['chest', 'length', 'sleeve', 'shoulder'];
    var LETTERS = ['A', 'B', 'C', 'D'];

    var SHAPES = {
      short: {
        body: 'M115,28 Q150,58 185,28 L215,38 L262,92 L236,114 L207,94 L207,244 L93,244 L93,94 L64,114 L38,92 L85,38 Z',
        details: ['M115,28 Q150,46 185,28', 'M70,108 L244,108'],
        lines: {
          chest: { d: 'M95,118 L205,118', badge: [80, 118], value: [150, 136], anchor: 'middle' },
          length: { d: 'M126,33 L126,242', badge: [126, 252], value: [134, 196], anchor: 'start' },
          sleeve: { d: 'M150,30 L213,38 L259,91', badge: [272, 84], value: [238, 50], anchor: 'start' },
          sleeveShoulder: { d: 'M214,40 L259,91', badge: [272, 84], value: [242, 56], anchor: 'start' },
          shoulder: { d: 'M87,44 L213,44', badge: [72, 44], value: [150, 62], anchor: 'middle' }
        }
      },
      long: {
        body: 'M116,30 Q150,54 184,30 L216,38 L286,206 L258,216 L212,104 L212,248 L88,248 L88,104 L42,216 L14,206 L84,38 Z',
        details: ['M116,30 Q150,44 184,30', 'M45,204 L19,194', 'M255,204 L281,194', 'M88,236 L212,236'],
        lines: {
          chest: { d: 'M90,120 L210,120', badge: [75, 120], value: [150, 138], anchor: 'middle' },
          length: { d: 'M126,34 L126,246', badge: [126, 258], value: [118, 196], anchor: 'end' },
          sleeve: { d: 'M150,31 L215,40 L271,210', badge: [285, 222], value: [252, 120], anchor: 'start' },
          sleeveShoulder: { d: 'M217,42 L271,210', badge: [285, 222], value: [252, 120], anchor: 'start' },
          shoulder: { d: 'M86,46 L214,46', badge: [71, 46], value: [150, 64], anchor: 'middle' }
        }
      }
    };

    function garmentShape(garment) {
      return garment === 'tee' ? 'short' : 'long';
    }

    class FormAdapter {
      constructor(formId) {
        this.formId = formId || null;
      }
      radios(name) {
        var formId = this.formId;
        return Array.prototype.filter.call(document.querySelectorAll('input[type="radio"]'), function (input) {
          return input.name === 'options[' + name + ']' && (!formId || input.getAttribute('form') === formId);
        });
      }
      wrapper(name) {
        var formId = this.formId;
        var scope = formId ? document.getElementById(formId) : null;
        var root = (scope && scope.closest('[data-product-form-wrapper]')) || document;
        return Array.prototype.find.call(root.querySelectorAll('[data-select-label]'), function (node) {
          return node.dataset.selectLabel === name;
        }) || null;
      }
      get(name) {
        var checked = this.radios(name).find(function (input) {
          return input.checked;
        });
        if (checked) return checked.value;
        var wrapper = this.wrapper(name);
        var current = wrapper && wrapper.querySelector('.select-popout__item--current [data-value], [data-value][aria-current="true"]');
        return current ? current.dataset.value : null;
      }
      set(name, value) {
        var radio = this.radios(name).find(function (input) {
          return input.value === value;
        });
        if (radio) {
          if (!radio.checked) radio.click();
          return true;
        }
        var wrapper = this.wrapper(name);
        var link = wrapper && Array.prototype.find.call(wrapper.querySelectorAll('[data-popout-option]'), function (node) {
          return node.dataset.value === value;
        });
        if (link) {
          link.click();
          return true;
        }
        return false;
      }
      apply(name, value) {
        var self = this;
        if (this.get(name) === value) return Promise.resolve();
        return new Promise(function (resolve) {
          var done = false;
          var finish = function () {
            if (done) return;
            done = true;
            window.removeEventListener('theme:section:update', onUpdate);
            window.requestAnimationFrame(function () {
              resolve();
            });
          };
          var onUpdate = function () {
            finish();
          };
          window.addEventListener('theme:section:update', onUpdate);
          if (!self.set(name, value)) finish();
          window.setTimeout(finish, 3500);
        });
      }
      subscribe(callback) {
        var formId = this.formId;
        var handler = function (event) {
          var input = event.target;
          if (!input || typeof input.name !== 'string' || input.name.indexOf('options[') !== 0) return;
          if (formId && input.getAttribute('form') !== formId) return;
          callback();
        };
        var clickHandler = function (event) {
          var link = event.target && event.target.closest && event.target.closest('[data-popout-option]');
          if (link) window.setTimeout(callback, 0);
        };
        var morphHandler = function () {
          callback();
        };
        document.addEventListener('change', handler);
        document.addEventListener('click', clickHandler);
        window.addEventListener('theme:section:update', morphHandler);
        return function () {
          document.removeEventListener('change', handler);
          document.removeEventListener('click', clickHandler);
          window.removeEventListener('theme:section:update', morphHandler);
        };
      }
    }

    class TargetAdapter {
      constructor(targetId) {
        this.targetId = targetId;
      }
      target() {
        return document.getElementById(this.targetId);
      }
      get(name) {
        var target = this.target();
        return target && target.getSize ? target.getSize(name) : null;
      }
      set(name, value) {
        var target = this.target();
        if (target && target.setSize) {
          target.setSize(name, value);
          return true;
        }
        return false;
      }
      apply(name, value) {
        this.set(name, value);
        return Promise.resolve();
      }
      subscribe(callback) {
        var handler = function (event) {
          if (event.target && event.target.id === this.targetId) callback();
        }.bind(this);
        document.addEventListener('bnp:set:change', handler);
        return function () {
          document.removeEventListener('bnp:set:change', handler);
        };
      }
    }

    class BnpSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        var dataNode = this.querySelector('script[data-bnp-sg-data]');
        if (!dataNode) return;
        try {
          this.data = JSON.parse(dataNode.textContent);
        } catch (e) {
          this.data = null;
        }
        this.labels = (this.data && this.data.labels) || {};
        this.options = (this.data && this.data.options) || [];
        this.variants = (this.data && this.data.variants) || [];
        this.charts = this.data ? this.buildCharts(this.data.charts || []) : [];
        this.revealTargetButtons();
        if (!this.charts.length) {
          var block = this.closest('.bnp-sg-block');
          (block || this).hidden = true;
          return;
        }
        this._ready = true;
        this.adapter = this.dataset.target ? new TargetAdapter(this.dataset.target) : new FormAdapter(this.dataset.formId);
        this.dialog = this.querySelector('dialog');
        this.panel = this.querySelector('[data-bnp-sg-panel]');
        this.live = this.querySelector('[data-bnp-sg-live]');
        this.readout = this.querySelector('[data-bnp-sg-readout]');
        this.tab = 0;
        this.unit = readUnit(this.charts[0].unit === 'cm' ? 'cm' : 'in');

        this.querySelectorAll('[data-bnp-sg-open]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            this.open(Number(button.dataset.chart || 0));
          }.bind(this));
        }, this);

        this.dialog.addEventListener('pointerdown', function (event) {
          this._downOnBackdrop = event.target === this.dialog;
        }.bind(this));
        this.dialog.addEventListener('click', function (event) {
          if (event.target === this.dialog && this._downOnBackdrop !== false) this.requestClose();
          this._downOnBackdrop = null;
        }.bind(this));
        this.dialog.addEventListener('cancel', function (event) {
          event.preventDefault();
          this.requestClose();
        }.bind(this));
        this.dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('bnp-sg-lock');
          this.removeAttribute('data-hl');
          this.confirming = false;
          this.applying = false;
        }.bind(this));

        this.unsubscribe = this.adapter.subscribe(function () {
          window.requestAnimationFrame(this.sync.bind(this));
        }.bind(this));
        this.sync();
      }

      revealTargetButtons() {
        if (!this.dataset.target) return;
        var target = document.getElementById(this.dataset.target);
        if (!target) return;
        target.querySelectorAll('[data-bnp-set-option]').forEach(function (fieldset) {
          var button = fieldset.querySelector('[data-bnp-set-guide]');
          if (!button) return;
          var option = this.options[Number(fieldset.dataset.bnpSetOption)];
          button.hidden = !option || !this.hasChartFor(option.name);
        }, this);
      }

      hasChartFor(name) {
        return !!(this.charts && this.charts.some(function (chart) {
          return chart.option && chart.option.name === name;
        }));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = null;
        this._ready = false;
        document.documentElement.classList.remove('bnp-sg-lock');
      }

      buildCharts(rawCharts) {
        var sizeOptions = this.options.filter(function (option) {
          return /size/i.test(option.name);
        });
        if (!sizeOptions.length && this.options.length) sizeOptions = [this.options[0]];
        var used = [];

        return rawCharts.map(function (raw, index) {
          if (!raw || !Array.isArray(raw.sizes) || !raw.sizes.length) return null;
          var garment = GARMENT_PATTERNS[raw.garment] ? raw.garment : 'tee';
          var pattern = GARMENT_PATTERNS[garment];
          var option = sizeOptions.find(function (candidate) {
            return used.indexOf(candidate.name) === -1 && pattern.test(candidate.name);
          }) || sizeOptions.filter(function (candidate) {
            return used.indexOf(candidate.name) === -1;
          })[0] || null;
          if (option) used.push(option.name);

          var measures = MEASURES.filter(function (key) {
            return Array.isArray(raw[key]) && raw[key].some(function (value) {
              return num(value) != null;
            });
          }).map(function (key, i) {
            return { key: key, letter: LETTERS[i], values: raw[key].map(num) };
          });

          var rows = raw.sizes.map(function (label, i) {
            var key = norm(label);
            var optionValue = option ? option.values.find(function (value) {
              return norm(value) === key;
            }) || null : null;
            return {
              label: String(label),
              key: key,
              optionValue: optionValue,
              values: measures.map(function (measure) {
                return measure.values[i] != null ? measure.values[i] : null;
              })
            };
          });
          if (rows.some(function (row) { return row.optionValue; })) {
            rows = rows.filter(function (row) { return row.optionValue; });
          }

          return {
            index: index,
            name: raw.name || '',
            garment: garment,
            unit: raw.unit === 'cm' ? 'cm' : 'in',
            fit: raw.fit || '',
            sleeveFrom: raw.sleeveFrom === 'shoulder' ? 'shoulder' : 'neck',
            howOverrides: raw.howOverrides || {},
            fabric: raw.fabric || '',
            how: raw.how || '',
            option: option,
            optionIndex: option ? this.options.indexOf(option) : -1,
            measures: measures,
            rows: rows,
            active: null
          };
        }, this).filter(Boolean);
      }

      currentRowIndex(chart) {
        if (!chart.option) return -1;
        var value = this.adapter.get(chart.option.name);
        if (value == null) return -1;
        var key = norm(value);
        return chart.rows.findIndex(function (row) {
          return row.key === key;
        });
      }

      isAvailable(chart, row) {
        if (!chart.option || !row.optionValue || !this.variants.length) return true;
        var optionIndex = chart.optionIndex;
        var selections = this.options.map(function (option) {
          return this.adapter.get(option.name);
        }, this);
        return this.variants.some(function (variant) {
          if (!variant.a || variant.o[optionIndex] !== row.optionValue) return false;
          return variant.o.every(function (value, i) {
            return i === optionIndex || selections[i] == null || selections[i] === value;
          });
        });
      }

      summary(chart, row) {
        var parts = chart.measures.slice(0, 2).map(function (measure, i) {
          return this.labels[measure.key] + ' ' + formatValue(row.values[i], chart.unit, this.unit);
        }, this);
        return parts.join(' · ');
      }

      sync() {
        this.updateReadout();
        if (this.dialog && this.dialog.open) this.render(true);
      }

      updateReadout() {
        if (this.readout) {
          this.readout.textContent = '';
          var lines = [];
          this.charts.forEach(function (chart) {
            var index = this.currentRowIndex(chart);
            if (index === -1) return;
            var row = chart.rows[index];
            var line = el('span', { className: 'bnp-sg__card-line' }, [
              el('strong', { text: (this.charts.length > 1 ? this.garmentName(chart) + ' ' : '') + row.label + ': ' }),
              this.summary(chart, row)
            ]);
            lines.push(line);
          }, this);
          if (lines.length) {
            lines.forEach(function (line, i) {
              if (i) this.readout.appendChild(el('br'));
              this.readout.appendChild(line);
            }, this);
          } else {
            this.readout.textContent = this.charts[0].fit || this.labels.card_hint || '';
          }
        }
      }

      garmentName(chart) {
        return this.labels['garment_' + chart.garment] || chart.garment;
      }

      open(chartIndex) {
        if (!this._ready || !this.dialog || !this.panel || !this.charts.length) return;
        this.highlight(null);
        this.confirming = false;
        this.applying = false;
        this.tab = Math.max(0, Math.min(this.charts.length - 1, chartIndex || 0));
        this.charts.forEach(function (chart) {
          var current = this.currentRowIndex(chart);
          chart.active = current !== -1 ? current : null;
        }, this);
        this.render();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('bnp-sg-lock');
        var focusTarget = this.panel.querySelector('.bnp-sg__pill[aria-pressed="true"]') || this.panel.querySelector('.bnp-sg__close');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      openForOption(optionName) {
        if (!this._ready) return false;
        var index = this.charts.findIndex(function (chart) {
          return chart.option && chart.option.name === optionName;
        });
        if (index === -1) return false;
        this.open(index);
        return true;
      }

      pendingChanges() {
        return this.charts.map(function (chart) {
          if (!chart.option || chart.active == null || chart.active === -1) return null;
          if (chart.active === this.currentRowIndex(chart)) return null;
          var row = chart.rows[chart.active];
          if (!row || !row.optionValue) return null;
          return { chart: chart, row: row, available: this.isAvailable(chart, row) };
        }, this).filter(Boolean);
      }

      describeChanges(changes) {
        var multi = this.charts.length > 1;
        return changes.map(function (change) {
          return (multi ? this.garmentName(change.chart) + ' ' : '') + change.row.label;
        }, this).join(' + ');
      }

      requestClose() {
        if (this.applying) return;
        var pending = this.pendingChanges().filter(function (change) {
          return change.available;
        });
        if (pending.length && !this.confirming) {
          this.confirming = true;
          this.render(true);
          var applyButton = this.panel.querySelector('[data-focus-key="confirm-apply"]');
          if (applyButton) applyButton.focus({ preventScroll: true });
          if (this.live) {
            this.live.textContent = '';
            window.setTimeout(function () {
              this.live.textContent = fill(this.labels.confirm_text, { sizes: this.describeChanges(pending) });
            }.bind(this), 50);
          }
          return;
        }
        if (this.confirming) this.discard();
        this.close();
      }

      discard() {
        this.charts.forEach(function (chart) {
          var current = this.currentRowIndex(chart);
          chart.active = current !== -1 ? current : null;
        }, this);
        this.confirming = false;
      }

      async applyPending() {
        if (this.applying) return;
        var changes = this.pendingChanges().filter(function (change) {
          return change.available;
        });
        this.applying = true;
        this.render(true);
        for (var i = 0; i < changes.length; i++) {
          await this.adapter.apply(changes[i].chart.option.name, changes[i].row.optionValue);
        }
        this.applying = false;
        this.confirming = false;
        this.close();
      }

      close() {
        if (this.dialog.open && typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          document.documentElement.classList.remove('bnp-sg-lock');
        }
      }

      setActive(rowIndex) {
        var chart = this.charts[this.tab];
        chart.active = rowIndex;
        this.confirming = false;
        this.highlight(null);
        this.render(true);
        this.announce(chart, chart.rows[rowIndex]);
      }

      setUnit(unit) {
        this.unit = unit;
        saveUnit(unit);
        this.sync();
        var chart = this.charts[this.tab];
        var row = chart.active != null && chart.active !== -1 ? chart.rows[chart.active] : null;
        this.announce(chart, row);
      }

      announce(chart, row) {
        if (!this.live || !row) return;
        var text = row.label + ': ' + this.summary(chart, row) + (this.isAvailable(chart, row) ? '' : ', ' + this.labels.sold_out);
        this.live.textContent = '';
        window.setTimeout(function () {
          this.live.textContent = text;
        }.bind(this), 50);
      }

      hover(node, key) {
        var self = this;
        node.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse') self.highlight(key);
        });
        node.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'mouse') self.highlight(null);
        });
      }

      highlight(key) {
        if (key) this.setAttribute('data-hl', key);
        else this.removeAttribute('data-hl');
      }

      render(keepScroll) {
        var scroller = this.panel.querySelector('.bnp-sg__scroll');
        var scrollTop = keepScroll && scroller ? scroller.scrollTop : 0;
        var focused = document.activeElement;
        var focusKey = focused && this.panel.contains(focused) ? focused.getAttribute('data-focus-key') : null;
        var chart = this.charts[this.tab];
        var labels = this.labels;
        var titleId = this.id + '-title';
        var self = this;

        this.panel.textContent = '';

        var close = el('button', { type: 'button', className: 'bnp-sg__close', 'aria-label': labels.close, 'data-focus-key': 'close' }, ['×']);
        close.addEventListener('click', function () {
          self.requestClose();
        });
        this.panel.appendChild(el('div', { className: 'bnp-sg__head' }, [
          el('div', null, [
            el('p', { className: 'bnp-sg__eyebrow', id: this.id + '-eyebrow', text: labels.eyebrow }),
            el('h2', { className: 'bnp-sg__title', id: titleId, text: chart.name || this.garmentName(chart) })
          ]),
          close
        ]));

        if (this.charts.length > 1) {
          var tabs = el('div', { className: 'bnp-sg__tabs', role: 'tablist' });
          var pendingCharts = this.pendingChanges().map(function (change) {
            return change.chart;
          });
          this.charts.forEach(function (item, i) {
            var itemCurrent = self.currentRowIndex(item);
            var itemActive = item.active != null && item.active !== -1 ? item.active : itemCurrent;
            var itemRow = itemActive != null && itemActive !== -1 ? item.rows[itemActive] : null;
            var isPending = pendingCharts.indexOf(item) !== -1;
            var tab = el('button', {
              type: 'button',
              className: 'bnp-sg__tab' + (isPending ? ' has-pending' : ''),
              role: 'tab',
              'aria-selected': i === self.tab ? 'true' : 'false',
              'aria-controls': self.id + '-tabpanel',
              tabindex: i === self.tab ? '0' : '-1',
              'data-focus-key': 'tab-' + i
            }, [
              self.garmentName(item) + (itemRow ? ' \u00b7 ' + itemRow.label : ''),
              isPending ? el('span', { className: 'visually-hidden', text: ' (' + self.labels.not_applied + ')' }) : null
            ]);
            tab.addEventListener('click', function () {
              self.tab = i;
              self.render();
              var next = self.panel.querySelector('[data-focus-key="tab-' + i + '"]');
              if (next) next.focus();
            });
            tab.addEventListener('keydown', function (event) {
              if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
              event.preventDefault();
              var dir = event.key === 'ArrowRight' ? 1 : -1;
              self.tab = (self.tab + dir + self.charts.length) % self.charts.length;
              self.render();
              var next = self.panel.querySelector('[data-focus-key="tab-' + self.tab + '"]');
              if (next) next.focus();
            });
            tabs.appendChild(tab);
          });
          this.panel.appendChild(tabs);
        }

        var scroll = el('div', {
          className: 'bnp-sg__scroll',
          id: this.id + '-tabpanel',
          role: this.charts.length > 1 ? 'tabpanel' : null,
          'aria-labelledby': titleId
        });
        this.panel.appendChild(scroll);

        if (this.data.model) {
          scroll.appendChild(el('p', { className: 'bnp-sg__model' }, [
            el('strong', { text: labels.model_label }),
            ' ' + this.data.model
          ]));
        }
        if (chart.fit) scroll.appendChild(el('p', { className: 'bnp-sg__fit', text: chart.fit }));

        var units = el('div', { className: 'bnp-sg__units', role: 'group', 'aria-label': labels.units });
        ['in', 'cm'].forEach(function (unit) {
          var button = el('button', {
            type: 'button',
            className: 'bnp-sg__unit',
            'aria-pressed': self.unit === unit ? 'true' : 'false',
            'data-focus-key': 'unit-' + unit,
            text: unit.toUpperCase()
          });
          button.addEventListener('click', function () {
            self.setUnit(unit);
          });
          units.appendChild(button);
        });
        scroll.appendChild(el('div', { className: 'bnp-sg__toolbar' }, [
          el('span', { text: labels.tap_size }),
          units
        ]));

        var currentIndex = this.currentRowIndex(chart);
        var activeIndex = chart.active != null ? chart.active : currentIndex;
        var pills = el('div', { className: 'bnp-sg__pills', role: 'group', 'aria-label': labels.size });
        chart.rows.forEach(function (row, i) {
          var available = self.isAvailable(chart, row);
          var pill = el('button', {
            type: 'button',
            className: 'bnp-sg__pill' + (available ? '' : ' is-sold-out') + (i === currentIndex ? ' is-current' : ''),
            'aria-pressed': i === activeIndex ? 'true' : 'false',
            'aria-label': row.label + (available ? '' : ' – ' + labels.sold_out) + (i === currentIndex ? ' – ' + labels.selected : ''),
            'data-focus-key': 'pill-' + i,
            text: row.label
          });
          pill.addEventListener('click', function () {
            self.setActive(i);
          });
          pills.appendChild(pill);
        });
        scroll.appendChild(pills);

        var activeRow = activeIndex != null && activeIndex !== -1 ? chart.rows[activeIndex] : null;
        scroll.appendChild(this.renderDiagram(chart, activeRow));

        var table = el('table', { className: 'bnp-sg__table' });
        var headRow = el('tr', null, [el('th', { scope: 'col', text: labels.size })]);
        chart.measures.forEach(function (measure) {
          var th = el('th', { scope: 'col', 'data-m': measure.key }, [
            el('span', { className: 'bnp-sg__letter', 'aria-hidden': 'true', text: measure.letter }),
            labels[measure.key]
          ]);
          self.hover(th, measure.key);
          headRow.appendChild(th);
        });
        table.appendChild(el('thead', null, [headRow]));
        var tbody = el('tbody');
        chart.rows.forEach(function (row, i) {
          var available = self.isAvailable(chart, row);
          var button = el('button', {
            type: 'button',
            className: 'bnp-sg__row-btn',
            'aria-pressed': i === activeIndex ? 'true' : 'false',
            'data-focus-key': 'row-' + i
          }, [row.label]);
          if (!available) button.appendChild(el('span', { className: 'bnp-sg__row-tag', text: labels.sold_out }));
          var tr = el('tr', { className: 'bnp-sg__row' + (i === activeIndex ? ' is-active' : '') + (available ? '' : ' is-sold-out') }, [
            el('th', { scope: 'row' }, [button])
          ]);
          row.values.forEach(function (value, m) {
            var td = el('td', { 'data-m': chart.measures[m].key, text: formatValue(value, chart.unit, self.unit) });
            self.hover(td, chart.measures[m].key);
            tr.appendChild(td);
          });
          tr.addEventListener('click', function (event) {
            if (event.target.closest('button') !== button) button.focus();
            self.setActive(i);
          });
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        scroll.appendChild(el('div', { className: 'bnp-sg__table-wrap' }, [table]));

        var chestIndex = chart.measures.findIndex(function (measure) { return measure.key === 'chest'; });
        if (chestIndex !== -1) scroll.appendChild(this.renderFinder(chart, chestIndex));

        var how = el('div', { className: 'bnp-sg__how' }, [el('h3', { className: 'bnp-sg__section-title', text: labels.how_title })]);
        var dl = el('dl');
        chart.measures.forEach(function (measure) {
          dl.appendChild(el('div', null, [
            el('dt', null, [el('span', { className: 'bnp-sg__letter', 'aria-hidden': 'true', text: measure.letter }), labels[measure.key]]),
            el('dd', { text: chart.howOverrides[measure.key] || labels['how_' + measure.key] })
          ]));
        });
        how.appendChild(dl);
        if (chart.how) how.appendChild(el('p', { className: 'bnp-sg__how-extra', text: chart.how }));
        scroll.appendChild(how);
        if (chart.fabric) scroll.appendChild(el('p', { className: 'bnp-sg__fabric', text: chart.fabric }));

        var footSummary = el('div', { className: 'bnp-sg__foot-summary' });
        var apply = el('button', { type: 'button', className: 'bnp-sg__apply', 'data-focus-key': 'apply' });
        var pendingAvailable = this.pendingChanges().filter(function (change) {
          return change.available;
        });
        if (this.applying) {
          footSummary.textContent = this.describeChanges(pendingAvailable);
          apply.disabled = true;
          apply.textContent = labels.applying;
        } else if (this.confirming && pendingAvailable.length) {
          var discard = el('button', { type: 'button', className: 'bnp-sg__discard', 'data-focus-key': 'confirm-discard', text: labels.confirm_discard });
          discard.addEventListener('click', function () {
            self.discard();
            self.close();
          });
          var confirmApply = el('button', { type: 'button', className: 'bnp-sg__apply', 'data-focus-key': 'confirm-apply', text: labels.confirm_apply });
          confirmApply.addEventListener('click', function () {
            self.applyPending();
          });
          this.panel.appendChild(el('div', { className: 'bnp-sg__foot bnp-sg__foot--confirm', role: 'alertdialog', 'aria-label': fill(labels.confirm_text, { sizes: this.describeChanges(pendingAvailable) }) }, [
            el('p', { className: 'bnp-sg__confirm-text', text: fill(labels.confirm_text, { sizes: this.describeChanges(pendingAvailable) }) }),
            el('div', { className: 'bnp-sg__confirm-actions' }, [discard, confirmApply])
          ]));
          apply = null;
        } else if (activeRow) {
          var activeAvailable = this.isAvailable(chart, activeRow);
          footSummary.appendChild(el('strong', { text: activeRow.label }));
          footSummary.appendChild(document.createTextNode(this.summary(chart, activeRow)));
          if (chart.option && activeRow.optionValue && !activeAvailable && activeIndex !== currentIndex) {
            apply.disabled = true;
            apply.textContent = fill(labels.sold_out_size, { size: activeRow.label });
          } else if (pendingAvailable.length) {
            apply.textContent = fill(labels.select, { size: this.describeChanges(pendingAvailable) });
            apply.addEventListener('click', function () {
              self.applyPending();
            });
          } else if (!chart.option || !activeRow.optionValue) {
            apply.hidden = true;
          } else {
            apply.textContent = labels.selected;
            apply.addEventListener('click', function () { self.close(); });
          }
        } else {
          footSummary.textContent = labels.tap_size;
          if (pendingAvailable.length) {
            apply.textContent = fill(labels.select, { size: this.describeChanges(pendingAvailable) });
            apply.addEventListener('click', function () {
              self.applyPending();
            });
          } else {
            apply.hidden = true;
          }
        }
        if (apply) this.panel.appendChild(el('div', { className: 'bnp-sg__foot' }, [footSummary, apply]));

        var newScroller = this.panel.querySelector('.bnp-sg__scroll');
        if (newScroller && scrollTop) newScroller.scrollTop = scrollTop;
        if (focusKey) {
          var refocus = this.panel.querySelector('[data-focus-key="' + focusKey + '"]');
          if (refocus) refocus.focus({ preventScroll: true });
        }
      }

      renderDiagram(chart, row) {
        var self = this;
        var shape = SHAPES[garmentShape(chart.garment)];
        var root = svg('svg', { viewBox: '0 0 300 270', className: 'bnp-sg__svg', role: 'img', 'aria-hidden': 'true', focusable: 'false' });
        root.setAttribute('class', 'bnp-sg__svg');
        if (chart.garment === 'hoodie') {
          root.appendChild(svg('path', { d: 'M116,30 C108,-6 192,-6 184,30', class: 'bnp-sg__garment' }));
        }
        root.appendChild(svg('path', { d: shape.body, class: 'bnp-sg__garment' }));
        shape.details.forEach(function (d) {
          root.appendChild(svg('path', { d: d, class: 'bnp-sg__detail' }));
        });
        if (chart.garment === 'jacket') {
          root.appendChild(svg('path', { d: 'M116,30 L132,62 L150,44 L168,62 L184,30', class: 'bnp-sg__detail' }));
          root.appendChild(svg('path', { d: 'M150,44 L150,248', class: 'bnp-sg__detail' }));
          [74, 112, 150, 188, 222].forEach(function (y) {
            root.appendChild(svg('circle', { cx: 156, cy: y, r: 3, class: 'bnp-sg__snap' }));
          });
        }
        if (chart.garment === 'hoodie') {
          root.appendChild(svg('path', { d: 'M112,184 L188,184 L198,232 L102,232 Z', class: 'bnp-sg__detail' }));
        }

        chart.measures.forEach(function (measure, i) {
          var spec = shape.lines[measure.key];
          if (measure.key === 'sleeve' && chart.sleeveFrom === 'shoulder' && shape.lines.sleeveShoulder) spec = shape.lines.sleeveShoulder;
          if (!spec) return;
          var group = svg('g', { class: 'bnp-sg__m', 'data-m': measure.key });
          group.appendChild(svg('path', { d: spec.d, class: 'bnp-sg__m-hit' }));
          group.appendChild(svg('path', { d: spec.d, class: 'bnp-sg__m-line' }));
          group.appendChild(svg('circle', { cx: spec.badge[0], cy: spec.badge[1], r: 10, class: 'bnp-sg__m-badge' }));
          var letter = svg('text', { x: spec.badge[0], y: spec.badge[1], class: 'bnp-sg__m-letter' });
          letter.textContent = measure.letter;
          group.appendChild(letter);
          if (row) {
            var value = svg('text', { x: spec.value[0], y: spec.value[1], class: 'bnp-sg__m-value', 'text-anchor': spec.anchor });
            value.textContent = formatValue(row.values[i], chart.unit, self.unit);
            group.appendChild(value);
          }
          self.hover(group, measure.key);
          group.addEventListener('click', function () {
            self.highlight(self.getAttribute('data-hl') === measure.key ? null : measure.key);
          });
          root.appendChild(group);
        });

        var visual = el('div', { className: 'bnp-sg__visual' });
        visual.appendChild(root);
        if (row) {
          var caption = chart.measures.map(function (measure, i) {
            return measure.letter + ' ' + self.labels[measure.key] + ' ' + formatValue(row.values[i], chart.unit, self.unit);
          }).join(', ');
          visual.appendChild(el('p', { className: 'bnp-sg__visual-hint', text: row.label + ' — ' + caption }));
        } else {
          visual.appendChild(el('p', { className: 'bnp-sg__visual-hint', text: this.labels.tap_size }));
        }
        return visual;
      }

      renderFinder(chart, chestIndex) {
        var self = this;
        var labels = this.labels;
        var inputId = this.id + '-finder-' + chart.index;
        var finder = el('div', { className: 'bnp-sg__finder' }, [
          el('h3', { className: 'bnp-sg__section-title', text: labels.finder_title }),
          el('p', { text: fill(labels.finder_text, { garment: this.garmentName(chart).toLowerCase() }) })
        ]);
        var input = el('input', {
          type: 'number',
          id: inputId,
          inputmode: 'decimal',
          min: '1',
          step: 'any',
          'aria-describedby': inputId + '-unit',
          'data-focus-key': 'finder-input'
        });
        if (chart.finderRaw != null && chart.finderRawUnit === this.unit) {
          input.value = chart.finderRaw;
        } else if (chart.finderValue != null) {
          input.value = this.unit === 'cm' ? Math.round(chart.finderValue * 2.54 * 2) / 2 : Math.round(chart.finderValue * 4) / 4;
          chart.finderRaw = input.value;
          chart.finderRawUnit = this.unit;
        }
        finder.appendChild(el('div', { className: 'bnp-sg__finder-row' }, [
          el('label', { className: 'bnp-sg__finder-label', for: inputId, text: labels.finder_label }),
          el('span', { className: 'bnp-sg__finder-input' }, [input, el('span', { id: inputId + '-unit', text: this.unit })])
        ]));
        var result = el('div', { className: 'bnp-sg__finder-result', 'aria-live': 'polite' });
        finder.appendChild(result);

        var update = function () {
          result.textContent = '';
          chart.finderRaw = input.value;
          chart.finderRawUnit = self.unit;
          var entered = num(input.value);
          if (entered == null || entered <= 0) {
            chart.finderValue = null;
            return;
          }
          var inches = self.unit === 'cm' ? entered / 2.54 : entered;
          chart.finderValue = inches;
          var best = -1;
          var bestDiff = Infinity;
          var bestInches = -Infinity;
          chart.rows.forEach(function (row, i) {
            var value = row.values[chestIndex];
            if (value == null) return;
            var rowInches = chart.unit === 'cm' ? value / 2.54 : value;
            var diff = Math.abs(rowInches - inches);
            var tie = Math.abs(diff - bestDiff) < 1e-6;
            if (diff < bestDiff - 1e-6 || (tie && rowInches > bestInches + 1e-6)) {
              best = i;
              bestDiff = diff;
              bestInches = rowInches;
            }
          });
          if (best === -1) return;
          var row = chart.rows[best];
          var use = el('button', { type: 'button', className: 'bnp-sg__finder-use', 'data-focus-key': 'finder-use', text: fill(labels.finder_use, { size: row.label }) });
          use.addEventListener('click', function () {
            self.setActive(best);
          });
          result.appendChild(el('div', { className: 'bnp-sg__finder-match' }, [
            el('span', null, [
              el('strong', { text: fill(labels.finder_result, { size: row.label, value: formatValue(row.values[chestIndex], chart.unit, self.unit) }) }),
              el('small', { text: labels.finder_between })
            ]),
            use
          ]));
        };
        input.addEventListener('input', update);
        update();
        return finder;
      }
    }

    customElements.define('bnp-size-guide', BnpSizeGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
